module.exports = __webpack_public_path__ + "assets/ertongjie.b37995e0.svg";